var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3238 12.5527C10.3238 11.7616 9.66766 11.1055 8.87648 11.1055C8.0853 11.1055 7.4292 11.7616 7.4292 12.5527C7.4292 13.3439 8.0853 14 8.87648 14C9.66766 14 10.3238 13.3439 10.3238 12.5527Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6203 8.7898C10.5555 6.72502 7.17855 6.72502 5.11377 8.7898L6.48386 10.1599C7.79606 8.84769 9.93803 8.84769 11.2695 10.1599L12.6203 8.7898Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0131 6.39705C13.3729 4.7568 11.1923 3.86914 8.87669 3.86914C6.56105 3.86914 4.38048 4.7761 2.74023 6.41635L4.11032 7.78644C6.73472 5.16204 11.038 5.16204 13.6624 7.78644L15.0131 6.39705Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3832 5.04618L17.7533 3.67608C12.8518 -1.22536 4.90145 -1.22536 0 3.67608L1.37009 5.04618C5.51895 0.897312 12.2343 0.897312 16.3832 5.04618Z",
    fill: "#AEAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon-wifi.b2993b4288612d4ad121960cb00ad5dc.svg";
export { ForwardRef as ReactComponent };